import { $base, BasicComponent } from "haxt";

import "./Header.scss";
import { RouterLink } from "../@noxtum/router/RouterLink";
import { Router } from "../@noxtum/router/Router";
import { Session } from "../@noxtum/session/Session";

type MenuItemData = {
	url: string;
	label: string;
	href?: string;
	disabled?: boolean;
	subItems?: MenuItemData[];
};


/*
GSI Website
	Home
		Welcome Message
		Join 'Ad'
		Dynamic: Current
	Events
		Conference of Irish Geographers
		Upcoming Events
		Geography Awareness Week
		GeoNight
	Study
		Primary
		Post-Primary
		Higher Education
		ASTI
		NCAA / Teaching Council
	About
		Who we are
		History of the Society
		Current Committee
			Sub-Committees
		AGM
			Motions
		Awards
			Previous Winners
			Current Winners
	Members
		Renew / Join
		Resources
		Log In
*/

const menuItems: () => MenuItemData[] = () => [
	{
		url: "home",
		label: "Home",
		href: "/"
	},
	{
		url: "events",
		label: "Events",
		subItems: [
			{ url: "conference", label: "Conference of Irish Geographers", href: "/events/conference" },
			{ url: "upcoming", label: "Upcoming Events", href: "/events/upcoming" },
			// { url: "awareness-week", label: "Geography Awareness Week", href: "/events/awareness-week" },
			// { url: "geonight", label: "GeoNight", href: "/events/geonight" },
			{ url: "past", label: "Past Events", href: "/events/past" }
		]
	},
	/*{
		url: "study",
		label: "Study",
		subItems: [
			{ url: "primary", label: "Primary", href: "/study/primary" },
			{ url: "post-primary", label: "Post-Primary", href: "/study/post-primary", disabled: true },
			{ url: "higher-education", label: "Higher Education", href: "/study/higher-education" },
			{ url: "agti", label: "AGTI", href: "/study/agti", disabled: true },
			{ url: "ncaa-teaching-council", label: "NCAA / Teaching Council", href: "/study/ncaa-teaching-council", disabled: true }
		]
	},*/
	{
		url: "journal",
		label: "Journal",
		href: "/journal"
	},
	{
		url: "about",
		label: "About",
		subItems: [
			{ url: "who-we-are", label: "Who we are", href: "/about/who-we-are" },
			// { url: "history", label: "History of the Society", href: "/about/history", disabled: true },
			{
				url: "current-committee", label: "Current Committee", href: "/about/current-committee",
				// subItems: [
				// 	{ url: "sub-committees", label: "Sub-Committees", href: "/about/sub-committees", disabled: true }
				// ]
			},
			{ url: "outreach", label: "Outreach", href: "/about/outreach" },
			/*{
				url: "agm", label: "AGM", href: "/about/agm", disabled: true,
				subItems: [
					{ url: "motions", label: "Motions", href: "/about/agm/motions", disabled: true }
				]
			},*/
			/*{
				url: "awards", label: "Awards", href: "/about/awards", disabled: true,
				subItems: [
					{ url: "previous-winners", label: "Previous Winners", href: "/about/awards/previous-winners", disabled: true },
					{ url: "current-winners", label: "Current Winners", href: "/about/awards/current-winners", disabled: true }
				]
			},*/
			{
				url: "contact", label: "Contact Us", href: "/about/contact"
			}
		]
	},
	{
		url: "projects",
		label: "Projects",
		href: "/projects"
	},
	{
		url: "members",
		label: "Members",
		subItems: [
			// Session.isLoggedIn() ? {
			// 	url: "area", label: "Members Area", href: "/members/area"
			// } : {
			// 	url: "log-in", label: "Log In", href: "/members/login"
			// },
			{ url: "renew-join", label: "Renew / Join", href: "/members/renew-join" },
			{ url: "rules", label: "Rules", href: "/members/rules" },
			{ url: "resources", label: "Resources", href: "/members/resources" }
		]
	}
];

export class MenuItem extends BasicComponent<{
	item: MenuItemData;
	current: string[];
}> {

	private opened: boolean = false;

	protected renderSubItems(items: MenuItemData[], current: string[] = []) {
		let page = Router.page;
		let parts = Router.parts;
		return items.map(item => {
			let isActive = page === item.url;
			// TODO: handle active states for sub-items?
			/*
			let isActive = true;
			if (current.length === 0) {
				isActive = page === item.url;
			} else {
				for (let i = 1; i < current.length; i++) {
					if (parts[i] !== current[i]) {
						isActive = false;
						break;
					}
				}
				// also check the main item
				if (parts.last !== item.url) {
					isActive = false;
				}
			}*/
			if (item.subItems && item.subItems.length > 0) {
				if (item.href) {
					return (
						<li>
							<RouterLink class={{ "menu-item": true, "active": isActive, "disabled": item.disabled === true }} href={item.href}>
								{item.label}
								{/* <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" class="-top-[1px] relative">
									<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 10l5 5l5-5"></path>
								</svg> */}
							</RouterLink>
							<ul>
								{this.renderSubItems(item.subItems, [...current, item.url])}
							</ul>
						</li>
					);
				} else {
					return (
						<li>
							<span class={{ "menu-item": true, "active": isActive, "disabled": item.disabled === true }}>
								{item.label}
								{/* <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" class="-top-[1px] relative">
									<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7 10l5 5l5-5"></path>
								</svg> */}
							</span>
							<ul>
								{this.renderSubItems(item.subItems, [...current, item.url])}
							</ul>
						</li>
					);
				}
			} else {
				return (
					<li>
						<RouterLink class={{ "menu-item": true, "active": isActive, "disabled": item.disabled === true }} href={item.href ?? "#"}>
							{item.label}
						</RouterLink>
					</li>
				);
			}
		});
	}

	@BasicComponent.initialize()
	protected initNavigationListener(): void {
		this.ref(Router.onUpdate.addCallback(() => {
			this.opened = false;
			this.update();
		}, this));
	}

	render() {
		let { item, current } = this.props;
		let page = Router.page;
		let isActive = page === item.url;
		let classes = {
			"menu-item": true,
			"active": isActive,
			"disabled": item.disabled === true
			// "opened": item.subItems && item.subItems.length > 0 && this.isActive
		};
		if (item.subItems && item.subItems.length > 0) {
			if (item.href) {
				throw new Error("Top level menu items with sub-items cannot have an href");
			} else {
				return (
					<li class={{ "menu-root": item.subItems && item.subItems.length > 0, "opened": this.opened }}>
						<span class={classes} onClick={() => {
							// this.opened = !this.opened;
							// this.update();
							// // TODO: better handling
							// const handleClickOutside = (event: MouseEvent) => {
							// 	if (!this[$base].node.contains(event.target as Node)) {
							// 		this.opened = false;
							// 		this.update();
							// 		document.removeEventListener("click", handleClickOutside);
							// 	}
							// };
							// document.addEventListener("click", handleClickOutside);
						}}>
							{item.label}
						</span>
						<ul>
							{this.renderSubItems(item.subItems, [...current, item.url])}
						</ul>
					</li>
				);
			}
		} else {
			return (
				<li class={{ "menu-root": item.subItems && item.subItems.length > 0, "opened": this.opened }}>
					<RouterLink class={classes} href={item.href ?? "#"}>
						{item.label}
					</RouterLink>
				</li>
			);
		}
	}
}

export class Header extends BasicComponent {
	private darkMode: boolean = false;
	private mobileMenuOpen: boolean = false;

	@BasicComponent.bind()
	private toggleTheme() {
		this.darkMode = !this.darkMode;
		this.update();

		if (this.darkMode) {
			document.documentElement.classList.add("dark");
		} else {
			document.documentElement.classList.remove("dark");
		}
	}

	@BasicComponent.bind()
	private toggleMobileMenu() {
		this.mobileMenuOpen = !this.mobileMenuOpen;
		this.update();
	}

	@BasicComponent.initialize()
	protected initRouter(): void {
		this.ref(Router.onUpdate.addCallback(this.update, this));
	}

	protected renderMenuItems(items: MenuItemData[], current: string[] = []) {
		return items.map(item => <MenuItem item={item} current={current} />);
	}

	private overlayHeader = Router.page === "home";

	private atTop = window.scrollY === 0;
	@BasicComponent.initialize()
	protected initScrollListener(): void {
		const handleScroll = () => {
			const isAtTop = window.scrollY === 0;
			if (this.atTop !== isAtTop) {
				this.atTop = isAtTop;
				this.update();
			}
		};

		window.addEventListener("scroll", handleScroll);
		this.onDestroy.addCallback(() => {
			window.removeEventListener("scroll", handleScroll);
		});

		this.ref(Router.onUpdate.addCallback(() => {
			const shouldOverlay = Router.page === "home";
			if (this.overlayHeader !== shouldOverlay) {
				this.overlayHeader = shouldOverlay;
				this.update();
			}
		}, this));
	}

	public render() {
		return (
			<header class={{ "Header": true, "at-top": this.atTop, "overlay": this.overlayHeader }}>
				<div class="menu-mobile">
					<img src="/images/gsi-logo-header.png" alt="Geographical Society Logo" />
					<button class="toggle-menu" aria-label="Toggle mobile menu" onClick={this.toggleMobileMenu}>
						<span></span>
						<span style="margin-top: 0.375rem;"></span>
						<span style="margin-top: 0.375rem;"></span>
					</button>
				</div>
				<div class={{
					"menu-top-container": true,
					"open": this.mobileMenuOpen
				}}>
					<div class="menu-mobile-close" onClick={this.toggleMobileMenu}>
						&times;
					</div>
					{/* <div class="container">
						<img src="/images/gsi-logo-header.png" alt="Geographical Society Logo" />
					</div> */}
					<div class="menu-top-wrapper">
						<div class="logo-container">
							<img src="/images/gsi-white-clear.png" alt="Geographical Society Logo" />
						</div>
						<div class="menu-top">
							<nav class="menu-top-left">
								<ul>
									{this.renderMenuItems(menuItems())}
								</ul>
							</nav>
							<div class="menu-top-right">
								{/* onClick={this.toggleTheme} */}
								<button aria-label="Toggle theme" class="theme-toggle" style="display: none;">
									<svg viewBox="0 0 16 16" class={{ "light": true, "hidden": this.darkMode }}>
										<path d="M4.50663 3.2267L3.30663 2.03337L2.36663 2.97337L3.55996 4.1667L4.50663 3.2267ZM2.66663 7.00003H0.666626V8.33337H2.66663V7.00003ZM8.66663 0.366699H7.33329V2.33337H8.66663V0.366699V0.366699ZM13.6333 2.97337L12.6933 2.03337L11.5 3.2267L12.44 4.1667L13.6333 2.97337ZM11.4933 12.1067L12.6866 13.3067L13.6266 12.3667L12.4266 11.1734L11.4933 12.1067ZM13.3333 7.00003V8.33337H15.3333V7.00003H13.3333ZM7.99996 3.6667C5.79329 3.6667 3.99996 5.46003 3.99996 7.6667C3.99996 9.87337 5.79329 11.6667 7.99996 11.6667C10.2066 11.6667 12 9.87337 12 7.6667C12 5.46003 10.2066 3.6667 7.99996 3.6667ZM7.33329 14.9667H8.66663V13H7.33329V14.9667ZM2.36663 12.36L3.30663 13.3L4.49996 12.1L3.55996 11.16L2.36663 12.36Z" fill="#FFFFFF"></path>
									</svg>
									<svg viewBox="0 0 23 23" class={{ "hidden": !this.darkMode }}>
										<path d="M16.6111 15.855C17.591 15.1394 18.3151 14.1979 18.7723 13.1623C16.4824 13.4065 14.1342 12.4631 12.6795 10.4711C11.2248 8.47905 11.0409 5.95516 11.9705 3.84818C10.8449 3.9685 9.72768 4.37162 8.74781 5.08719C5.7759 7.25747 5.12529 11.4308 7.29558 14.4028C9.46586 17.3747 13.6392 18.0253 16.6111 15.855Z"></path>
									</svg>
								</button>
								{/* <a class="button-sign-in" href="#">Sign In</a>
								<a class="button-sign-up" href="#">Sign Up</a> */}
							</div>
						</div>
					</div>
				</div>
				<div class="spacer" />
			</header>
		);
	}
}
